import Helpers from "commons/helpers";
import Constants from "constants/index";
import IdentityService from "./identity.service";

class OrganizationService extends IdentityService {

    public getAll = async (data: {
        type?: number;
        clientId?: string;
        status?: number[];
        serviceCheck?: boolean;
    }) => {
        const query = Helpers.handleFormatParams(data);
        const result = await this.api.get({
            path: Constants.ApiPath.ORGANIZATION.GET_ALL + `${query ? "?" : ""}${query}`,
        });
        return result.data.result;
    };

    public getPaged = async (data: {
        type?: number;
        status?: number[];
        clientId?: string;
        searchText?: string;
        serviceCheck?: boolean;
        organizationCode?: string;
        orderby?: string;
        pageSize?: number;
        pageNumber?: number;
    }) => {
        const query = Helpers.handleFormatParams(data);
        const result = await this.api.get({
            path: Constants.ApiPath.ORGANIZATION.GET_PAGED + `${query ? "?" : ""}${query}`,
        });
        return result.data.result;
    };
}

export default OrganizationService;
